import { render, staticRenderFns } from "./CertifiedExperts.vue?vue&type=template&id=c8f94e68&scoped=true"
import script from "./CertifiedExperts.vue?vue&type=script&lang=js"
export * from "./CertifiedExperts.vue?vue&type=script&lang=js"
import style0 from "./CertifiedExperts.vue?vue&type=style&index=0&id=c8f94e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f94e68",
  null
  
)

export default component.exports